import { FrameEditOrder } from '@Modules/Orders';
import { Badge, useLinkedObjectOverlay, type LinkableField } from '@synqo/frontend-component-library';
import { useCallback, type FC } from 'react';

export type LinkOrderProps = {
    order: LinkableField;
};

export const LinkOrder: FC<LinkOrderProps> = ({ order }) => {
    const { onClick: clickLinkedOrder } = useLinkedObjectOverlay({
        Renderer: FrameEditOrder,
        canAdd: false,
    });

    const nonNullOrderId = order.foreign_key ?? '';
    const openOrderInModal = useCallback(() => {
        clickLinkedOrder(nonNullOrderId);
    }, [clickLinkedOrder, nonNullOrderId]);
    return (
        <Badge variant="brand" onClick={openOrderInModal}>
            Auftrag {order.display_string}
        </Badge>
    );
};
